import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getIsLoggedSelector } from '../redux/auth/selectors';

export const ProtectedRoute = ({ Component, ...props }: any) => {
    const isLogged = useSelector(getIsLoggedSelector);
    return isLogged ? <Component {...props} /> : <Navigate to="/bo/auth/login" />;
};
